import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const reviews = [{
  name: 'Emma Wilson',
  location: 'Glasgow West End',
  rating: 5,
  text: 'Absolutely fantastic service. The team arrived on time and left my apartment spotless. The end of tenancy clean secured my full deposit back. Highly recommended!'
}, {
  name: 'James Roberts',
  location: 'Shawlands',
  rating: 5,
  text: 'We use Cleen Co for our office cleaning weekly. They are professional, thorough, and very trustworthy. It makes such a difference coming into a clean workspace on Mondays.'
}, {
  name: 'Sarah Anderson',
  location: 'Bearsden',
  rating: 5,
  text: "Booked a deep clean after renovations. I couldn't believe the difference. They managed to get rid of all the dust and the place smells amazing. Thank you!"
}];
export function Testimonials() {
  return <section id="reviews" className="py-20 bg-white border-t border-gray-100" data-id="element-216">
      <div className="container mx-auto px-4 md:px-6" data-id="element-217">
        <div className="text-center mb-16" data-id="element-218">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-219">
            What Our Customers Say
          </h2>
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-220">
            <div className="flex gap-1" data-id="element-221">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 text-yellow-400 fill-yellow-400" data-id="element-222" />)}
            </div>
            <span className="font-semibold text-gray-900" data-id="element-223">4.9/5</span>
            <span className="text-gray-500" data-id="element-224">from 200+ reviews</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-225">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-gray-50 p-8 rounded-2xl relative" data-id="element-226">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-teal-100" data-id="element-227" />
              <div className="flex gap-1 mb-4" data-id="element-228">
                {[...Array(review.rating)].map((_, i) => <Star key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-229" />)}
              </div>
              <p className="text-gray-700 mb-6 italic leading-relaxed" data-id="element-230">
                "{review.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-231">
                <div className="w-10 h-10 rounded-full bg-teal-600 flex items-center justify-center text-white font-bold" data-id="element-232">
                  {review.name.charAt(0)}
                </div>
                <div data-id="element-233">
                  <div className="font-bold text-gray-900" data-id="element-234">{review.name}</div>
                  <div className="text-xs text-gray-500" data-id="element-235">{review.location}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}